import React, { Fragment, useEffect, useState, useContext, useRef } from "react";

import { RestHelper } from "../../helper/restHelper";
import { UserContext } from "../../app"
import {AdminAssignDirect} from "../../components/admin";
import { PopupOverlay, GeneralGroupFileUpload, GeneralUploadStatus} from "../../components"


const AdminEditRequest = (data) => {

    const {userProfile, setUser } = useContext(UserContext)
    const [request, setRequest] = useState({
        apptName:"",
        apptDate:"",
        apptTime:"",
        apptTimeTBD: false,
        apptTimeZone: "CT",
        apptStreet:"",
        apptCity:"",
        apptState:"",
        apptZip:"",
        apptOffer:"",
        email:"",
        comments:"",
        apptLender:"",
        fileNumber:"",
        userProfile:"",
        contactName:"",
        contactPhone1:"",
        contactPhone2:"",
        contactEmail1:"",
        contactEmail2:"",
        unique_id:"",
        appt_fee:"",
        scanBack: false,
        transactionType: '',
        financeType: '',
        notaryCount: 0,
        preferredNotary: [],
        fileLogInfo: []
    })
    const [profileLoaded, setProfileLoaded] = useState(false)
    const [editFlag, setEditFlag] = useState(true)
    const [notaryFeeEditFlag, setNotaryFeeEditFlag] = useState(true)
    const [errorMessage, setErrorMessage] = useState(false)
    const [showForm, setShowForm] = useState(true)
    const [apiMessage, setApiMessage] = useState('')
    const [apiDetails, setApiDetails] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [isLoaded, setIsLoaded] = useState(false)
    const [requireTime, setRequireTime] = useState(true)
    const [editedContent, setEditedContent] = useState(false)
    const [directlyAssign, setDirectlyAssign] = useState(false)
    const [showResponseMessage, setShowResponseMessage] = useState(false)
    const [responseMessage, setResponseMessage] = useState('')
    const [passedMessage, setPassedMessage] = useState('')
    const [passedObject, setPassedObject] = useState('')
    const [showPopup, setShowPopup] = useState(false)


    const commentsRef = useRef(null)
    const api = RestHelper()


    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
    
    useEffect(() => {
        if (!isLoaded) {
            setIsLoading(true)
            setShowForm(false)
            const reqData = {'action' : 'get', 'request_id' : data['requestId'] }
            const options = {}
            api
                .postCreate('/manage-appts-admin', options, reqData)
                .then(res => initialLoad(res))
                .catch(err => console.log(err))
        }
    },[])

    const initialLoad = (res) => {
        setRequest({
            ...request,
            ['apptName'] : res['appt_name'],
            ['apptDate'] : res['appt_date'],
            ['apptTime'] : res['appt_time'],
            ['apptTimeTBD'] : res['appt_time_TBD'],
            ['apptTimeZone'] : res['appt_timeZone'],
            ['apptStreet'] : res['appt_address'],
            ['apptCity'] : res['appt_city'],
            ['apptState'] : res['appt_state'],
            ['apptZip'] : res['appt_zip'],
            ['apptOffer'] : res['appt_offer'],
            ['email'] : res['appt_escrow_email'],
            ['appt_firm_name'] : res['appt_firm_name'],
            ['appt_escrow'] : res['appt_escrow'],
            ['comments'] : res['appt_notes'],
            ['fileNumber'] : res['fileNumber'],
            ['apptLender'] : res['appt_lender'],
            ['userProfile'] : res['userProfile'],
            ['contactName'] : res['appt_contactName'],
            ['contactPhone1'] : res['appt_contactPhone1'],
            ['contactPhone2'] : res['appt_contactPhone2'],
            ['contactEmail1'] : res['appt_contactEmail1'],
            ['contactEmail2'] : res['appt_contactEmail2'],
            ['unique_id'] : res['unique_id'],
            ['appt_fee'] : res['appt_fee'],
            ['scanBack'] : res['scanBack'],
            ['transactionType'] : res['transactionType'],
            ['financeType'] : res['financeType'],
            ['notaryCount'] : res['notaryCount'],
            ['preferredNotary'] : res['preferredNotary'],
            ['fileLogInfo'] : res['fileLogInfo']
        })
        
        setIsLoading(false)
        setShowForm(true)
        if (res['appt_time_TBD']) {
            setRequireTime(false)
        }
        setScanBack(res['scanBack'])
        setTransactionType(res['transactionType'])
        setFinanceType(res['financeType'])
        setEditFlag(false)
        setIsLoaded(true)
        
    }

    const onChangeEvent = (evt) => {
        setEditedContent(true)
        var value = evt.target.value;
        // Use name for radio buttons, id for other inputs
        var fieldName = evt.target.type === 'radio' ? evt.target.name : evt.target.id;
        if (fieldName == 'apptOffer') {
            value = value.replace('$', '')
        }
        if (fieldName == 'appt_fee') {
            value = value.replace('$', '')
        }
        setRequest({
            ...request,
            [fieldName]: value
        })

    }
    
    const setScanBack = (initialValue) => {
        if (initialValue === 'true') {
            var radioButton = document.querySelector("input[value='true']")
            radioButton.checked = true;
        }
        else {
            var radioButton = document.querySelector("input[value='false']")
            radioButton.checked = true;
        }
    }

    const setTransactionType = (initialValue) => {
        if (initialValue === '1') {
            var radioButton = document.querySelector("input[value='1']")
            radioButton.checked = true;
        }
        else if (initialValue === '2') {
            var radioButton = document.querySelector("input[value='2']")
            radioButton.checked = true;
        }
        else if (initialValue === '3') {
            var radioButton = document.querySelector("input[value='3']")
            radioButton.checked = true;
        }
        else if (initialValue === '4') {
            var radioButton = document.querySelector("input[value='4']")
            radioButton.checked = true;
        }
    }

    const setFinanceType = (initialValue) => {
        if (initialValue === '11') {
            var radioButton = document.querySelector("input[value='11']")
            radioButton.checked = true;
        }
        else if (initialValue === '12') {
            var radioButton = document.querySelector("input[value='12']")
            radioButton.checked = true;
        }
        else if (initialValue === '13') {
            var radioButton = document.querySelector("input[value='13']")
            radioButton.checked = true;
        }
        else if (initialValue === '14') {
            var radioButton = document.querySelector("input[value='14']")
            radioButton.checked = true;
        }
        else if (initialValue === '15') {
            var radioButton = document.querySelector("input[value='15']")
            radioButton.checked = true;
        }
        else if (initialValue === '16') {
            var radioButton = document.querySelector("input[value='16']")
            radioButton.checked = true;
        }
    }

    const setCheckBox = (initialValue) => {
        const checkboxArray = ['apptTimeTBD']
        checkboxArray.forEach(value => {
            const checkBoxVar = document.getElementById(value)
            if (initialValue){
                if (initialValue != checkBoxVar.checked){
                    checkBoxVar.click()}
                }
        })
    }

    const stateOptions = ['', 'AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI',
        'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC',
        'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX',
        'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY']

    useEffect(() => {
        setRequest({
            ...request,
            ['userProfile']: userProfile.profileEmail
        })
    },[isLoaded]);

    const autoResizeComments = (el) => {
        if (!el) return;
        el.style.height = '1px';
        el.style.height = el.scrollHeight + 'px';
    }

    //const stateVar = document.getElementById('certifiedState1Select')
    
    const clearErrorMessage = () => {
        setErrorMessage(false)
        setShowForm(true)
        setProfileLoaded(!profileLoaded)
        setNotaryFeeEditFlag(false)
        setEditFlag(false)
    }

    const updateTimeFieldInitial = (value) => {

        if(value){
          setRequireTime(false)
          setRequest({
            ...request,
            ['apptTime']: '00:00'
        })
        }
      }

    const updateTimeField = () => {

        if(requireTime){
          setRequireTime(false)
          setRequest({
            ...request,
            ['apptTime']: '00:00',
            ['apptTimeTBD'] : true
        })
        }
        else{
          setRequireTime(true)
          setRequest({
            ...request,
            ['apptTime']: '',
            ['apptTimeTBD'] : false
        })
        }
      }
    const addState = (evt) => {
        const value = evt.target.id
        setRequest({
            ...request,
            [value] : evt.target.value
        })
    }

    const setApiRes = (res) => {
        setErrorMessage(true)
        setShowForm(false)
        setIsLoading(false)
        setApiDetails(res['details'])
        setApiMessage(res['returnMessage'])
    }
    
    const updateEditFlags = (e) => {
        setEditFlag(e)
        setNotaryFeeEditFlag(e)
    }
   
    const callApi = () => {
        const options = {}
        const reqData = {'action' : 'update', 'request_id' : data['requestId'], 'data' : request }
        setIsLoading(true)
        setShowForm(false)
        setEditedContent(false)
        api
        .postCreate('/manage-appts-admin', options, reqData)
        .then(res => setApiRes(res))
        .catch(err => setApiRes(err))
    }

    const submitNotify = () => {
        const options = {}
        const reqData = {'action' : 'notify', 'request_id' : data['requestId']}
        setIsLoading(true)
        setShowForm(false)
        api
        .postCreate('/manage-appts-admin', options, reqData)
        .then(res => setApiRes(res))
        .catch(err => setApiRes(err))
    }

    const submitPreferNotify = () => {
        const options = {}
        const reqData = {'action' : 'notifyPrefer', 'request_id' : data['requestId']}
        setIsLoading(true)
        setShowForm(false)
        api
        .postCreate('/manage-appts-admin', options, reqData)
        .then(res => setApiRes(res))
        .catch(err => setApiRes(err))
    }

    const assignDirect = () => {
        setShowForm(false)
        setDirectlyAssign(true)
    }

    const setFee = () => {
        const fee = '$' + request.apptOffer
        return fee
    }
    function setResponse(res) {
        setResponseMessage(res['message'])
        setIsLoading(false)
        setShowResponseMessage(true)
        
    }

    const updateStatus = (e) => {
        setIsLoading(true)
        setShowForm(false)
        const options = {}
        const reqData = { 'action': e, 'request_id': data['requestId'] }
        api
            .postCreate('/manage-appts-admin', options, reqData)
            .then(res => setResponse(res))
            .catch(err => console.log(err))
    }

    const setServiceFee = () => {
        const fee = '$' + request.appt_fee
        return fee
    }

    const convertToDate = (updatedTime) => {
        const date = new Date(updatedTime * 1000)
        return date
    }
    function convertToSimpleDateMessage(updatedTime) {
        const date = new Date(updatedTime * 1000)
        const dateString = date.toLocaleString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        })
        return dateString
    }

    function setAction(passedAction) {
        if (passedAction === 'write') {
            return 'Uploaded'
        }
        else {
            return 'Downloaded'
        }
    }

    const getTempUrl = (e) => {
        const options = {}
        const fileData = { 'unique_id': data.requestId, 'file_name': e }
        api
            .postCreate('/get-stored-file', options, fileData)
            .then(res => window.open(res.get_url, "_blank"))
            .catch(err => console.log(err))
    }
    function deleteFile(e) {
        //callDeleteFileService(e)
        var messageToSend = 'Are you sure you wish to delete ' + e + '?'
        setPassedMessage(messageToSend)
        setPassedObject(e)
        setShowPopup(true)
        const btnRef = document.getElementById(e)
        btnRef.blur()
        console.log(e)
    }

    function clearModal() {
        setShowPopup(false)
    }

    function clearResponseMessage() {
        const reqData = { 'action': 'getFileLog', 'request_id': data.requestId }
        const options = {}
        api
            .postCreate('/manage-appts-admin', options, reqData)
            .then(res => setLogInfo(res))
            .catch(err => console.log(err))
    }

    function callDeleteFileService(inputData) {
        const reqData = { 'action': 'deleteFile', 'request_id': data.requestId, 'fileName': inputData }
        const options = {}
        api
            .postCreate('/manage-appts-admin', options, reqData)
            .then(res => clearResponseMessage())
            .catch(err => console.log(err))
    }

    function confirmAction(e) {
        callDeleteFileService(e)
    }

    function setLogInfo(res){
        setRequest({
            ...request,
            ['fileLogInfo']: res
        })
    }

    const onSubmitHandler = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        // If editFlag is true, the preview button was selected and the updated form values are ready for review
        if ( notaryFeeEditFlag ){
            setEditFlag(false)
            setNotaryFeeEditFlag(false)
        }
        // If editFlag was false, the form was in a preview mode and ready to be submitted
        else {
            callApi()
            setEditFlag(true)
            setNotaryFeeEditFlag(true)
        }
    }

    return (
        <Fragment>
            {errorMessage && (
                <div className="container border rounded">
                <div className='row rounded bg-white'>
                 <button className="close ml-3 mb-2 mt-2" aria-label="Close" onClick={() =>clearErrorMessage()}>
                  <span aria-hidden='false'>&times;</span>
                 </button>
                </div>
                <div className="card mb-3 mt-3">
                    <div className="card-body rounded-border bg-white">
                        <h5 className='card-title'>Appointment Status</h5>
                        <h6 className='card-subtitle mb-2'>{ apiMessage }</h6>
                        <h5 className='card-subtitle mb-2'>{ apiDetails }</h5>
                    </div>
              </div>
              </div>
            )}
            {showForm && (
            <div className="container rounded border bg-white mt-4 mb-4" id="myInput">
                <div className='mb-3 mt-3 mx-3'><h4>Review and Edit Submitted Appointment</h4></div>
            <div>
            <form onSubmit={(e)=>onSubmitHandler(e)} className="needs-validation">
             <div className="card mb-3 mt-3">
             <div className="card-body rounded border bg-light">
              <h5 className="card-title">Event Details ( * required field)</h5>
              <div className="row">
               <div className="col mb-3 mt-2">
                <label htmlFor="apptName" className='form-label'>Appointment Name *</label>
                {editFlag
                ? <input className='form-control' id="apptName" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptName} required />
                : <input className='form-control' id="apptName" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptName} required readOnly/>}
               </div>
              </div>
              <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 row-cols-lg-5">
               <div className="col mb-3 mt-2">
                <label htmlFor="apptDate" className='form-label'>Date *</label>
                {editFlag
                ? <input className='form-control' id="apptDate" onChange={(e)=>onChangeEvent(e)} type="date" value={request.apptDate} required/>
                : <input className='form-control' id="apptDate" onChange={(e)=>onChangeEvent(e)} type="date" value={request.apptDate} required readOnly/>}
               </div>
               <div className="form-check col col-auto mb-3 mt-2">
                    <label className="form-check-label">
                        Time TBD
                    </label>
                    {editFlag
                    ? <input className="form-check-input mx-2" type="checkbox" value="" id="apptTimeTBD" checked={request.apptTimeTBD} onChange={() => {updateTimeField()}}/>
                    : <input className="form-check-input mx-2" type="checkbox" value="" id="apptTimeTBD" checked={request.apptTimeTBD} disabled/>}
                </div>
               <div className="col mb-3 mt-2">
                {requireTime
                ?(<div><label htmlFor="apptTime" className='form-label'>Time *</label>
                {editFlag
                ? <input className='form-control' id="apptTime" onChange={(e)=>onChangeEvent(e)} type="time" value={request.apptTime} required/>
                : <input className='form-control' id="apptTime" onChange={(e)=>onChangeEvent(e)} type="time" value={request.apptTime} required readOnly/>}</div>)
                : <div><label htmlFor="apptTime" className='form-label'>Time *</label><input className='form-control' id='apptTimeTBDBox' value='TBD' readOnly/></div>}
               </div>
               <div className="col mb-3 mt-2">
                <label htmlFor="apptTimeZone" className='form-label'>Timezone</label>
                <select
                  className='form-select form-select-sm mb-3 col'
                  aria-label='form-select-sm'
                  id="apptTimeZone"
                  value={request.apptTimeZone}
                  onChange={(e)=>onChangeEvent(e)}
                  disabled={!editFlag}
                >
                  <option value='ET'>Eastern</option>
                  <option value='CT'>Central</option>
                  <option value='MT'>Mountain</option>
                  <option value='PT'>Pacific</option>
                  <option value='HT'>Hawaii</option>
                  <option value='AK'>Alaska</option>
                </select>
                </div>
              </div>
              <div className="row">
               <div className="col mb-3 mt-2">
                <label htmlFor="apptStreet" className='form-label'>Address *</label>
                {editFlag
                ? <input className='form-control' id="apptStreet" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptStreet} required />
                : <input className='form-control' id="apptStreet" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptStreet} required readOnly/>}
               </div>
              </div>
              <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4">
               <div className="col mb-3 mt-2">
                <label htmlFor="apptCity" className='form-label'>City *</label>
                {editFlag
                ? <input className='form-control' id="apptCity" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptCity} required/>
                : <input className='form-control' id="apptCity" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptCity} required readOnly/>}
               </div>
               <div className="col mb-3 mt-2">
               <label htmlFor="apptState" className='form-label col'>State *</label>
                  <select
                    className='form-select form-select-sm mb-3 col'
                    aria-label='form-select-sm'
                    id="apptState"
                    value={request.apptState}
                    onChange={(e)=>addState(e)}
                    disabled={!editFlag}
                    required
                  >
                    {stateOptions.map(state => (
                      <option key={state} value={state}>
                        {state === '' ? 'Select State' : state}
                      </option>
                    ))}
                  </select>
               </div>
               <div className="col mb-3 mt-2">
                <label htmlFor="apptZip" className='form-label'>Zip Code *</label>
                {editFlag
                ? <input className='form-control' id="apptZip" maxLength="5" onChange={(e)=>onChangeEvent(e)} type="tel" value={request.apptZip} required/>
                : <input className='form-control' id="apptZip" onChange={(e)=>onChangeEvent(e)} type="tel" value={request.apptZip} required readOnly/>}
               </div>
              </div>
              <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3">
              <div className="col mb-3 mt-2">
                <label htmlFor="apptOffer" className='form-label'>Offered Signing Agent Fee</label>
                {notaryFeeEditFlag
                ? <input className='form-control' id="apptOffer" onChange={(e)=>onChangeEvent(e)} type="text" value={setFee()} required/>
                : <input className='form-control' id="apptOffer" onChange={(e)=>onChangeEvent(e)} type="text" value={setFee()} required readOnly/>}
               </div>
               <div className="col mb-3 mt-2">
                <label htmlFor="apptLender" className='form-label'>Lender</label>
                {editFlag
                ? <input className='form-control' id="apptLender" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptLender} />
                : <input className='form-control' id="apptLender" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptLender} readOnly/>}
               </div>
              </div>
              <hr/>
              <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 mx-2">
                <label className="form-label mx-2 col">SCAN BACK REQUIRED?</label>
                <label className="form-label mx-2 col">
                  <div><input className="mx-2" type="radio" name="scanBack" id="scanBackTrue" onChange={(e)=>onChangeEvent(e)} value="true" checked={request.scanBack === 'true' || request.scanBack === true} required disabled={!editFlag}/>Required</div>
                </label>
                <label className="form-label mx-2 col">
                  <div><input className="mx-2" type="radio" name="scanBack" id="scanBackFalse" onChange={(e)=>onChangeEvent(e)} value="false" checked={request.scanBack === 'false' || request.scanBack === false} required disabled={!editFlag}/>Not Required</div>
                </label>
              </div>
              <hr/>
              <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 mx-2">
                <label className="form-label mx-2 col">TYPE OF TRANSACTION:</label>
                <label className="form-label mx-2 col">
                  <div><input className="mx-2" type="radio" name="transactionType" id="transactionType1" onChange={(e)=>onChangeEvent(e)} value={'1'} checked={request.transactionType === '1'} required disabled={!editFlag}/>Purchase (Buyer Side)</div>
                </label>
                <label className="form-label mx-2 col">
                  <div><input className="mx-2" type="radio" name="transactionType" id="transactionType2" onChange={(e)=>onChangeEvent(e)} value={'2'} checked={request.transactionType === '2'} required disabled={!editFlag}/>Refinance</div>
                </label>
                <label className="form-label mx-2 col">
                  <div><input className="mx-2" type="radio" name="transactionType" id="transactionType3" onChange={(e)=>onChangeEvent(e)} value={'3'} checked={request.transactionType === '3'} required disabled={!editFlag}/>Seller Side Closing</div>
                </label>
                <label className="form-label mx-2 col">
                  <div><input className="mx-2" type="radio" name="transactionType" id="transactionType4" onChange={(e)=>onChangeEvent(e)} value={'4'} checked={request.transactionType === '4'} required disabled={!editFlag}/>Other (Warranty deed, etc)</div>
                </label>
              </div>
              <hr/>
              <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 mx-2">
                <label className="form-label mx-2 col">TYPE OF FINANCING: (Optional)</label>
                <label className="form-label mx-2 col">
                  <div><input className="mx-2" type="radio" name="financeType" id="financeType11" onChange={(e)=>onChangeEvent(e)} value={'11'} checked={request.financeType === '11'} disabled={!editFlag}/>FHA</div>
                </label>
                <label className="form-label mx-2 col">
                  <div><input className="mx-2" type="radio" name="financeType" id="financeType16" onChange={(e)=>onChangeEvent(e)} value={'16'} checked={request.financeType === '16'} disabled={!editFlag}/>VA</div>
                </label>
                <label className="form-label mx-2 col">
                  <div><input className="mx-2" type="radio" name="financeType" id="financeType12" onChange={(e)=>onChangeEvent(e)} value={'12'} checked={request.financeType === '12'} disabled={!editFlag}/>Conventional</div>
                </label>
                <label className="form-label mx-2 col">
                  <div><input className="mx-2" type="radio" name="financeType" id="financeType13" onChange={(e)=>onChangeEvent(e)} value={'13'} checked={request.financeType === '13'} disabled={!editFlag}/>Reverse</div>
                </label>
                <label className="form-label mx-2 col">
                  <div><input className="mx-2" type="radio" name="financeType" id="financeType14" onChange={(e)=>onChangeEvent(e)} value={'14'} checked={request.financeType === '14'} disabled={!editFlag}/>HELOC</div>
                </label>
                <label className="form-label mx-2 col">
                  <div><input className="mx-2" type="radio" name="financeType" id="financeType15" onChange={(e)=>onChangeEvent(e)} value={'15'} checked={request.financeType === '15'} disabled={!editFlag}/>Commercial</div>
                </label>
              </div>
              <hr/>
              <div className="mb-3 mt-2">
               <label htmlFor="fileNumber" className='form-label'>File Number</label>
               {editFlag
               ? <input className='form-control' id="fileNumber" onChange={(e)=>onChangeEvent(e)} type="text" value={request.fileNumber} />
               : <input className='form-control' id="fileNumber" onChange={(e)=>onChangeEvent(e)} type="text" value={request.fileNumber} readOnly/>}
              </div>
              <div className="mb-3 mt-2">
               <label htmlFor="comments" className='form-label'>Additional Comments (max length = 400 characters)</label>
               <textarea
                   ref={commentsRef}
                   className='form-control'
                   id="comments"
                   maxLength='400'
                   onChange={(e) => onChangeEvent(e)}
                   value={request.comments}
                   readOnly={!editFlag}
                   rows={1}
                   ref={(el) => { commentsRef.current = el; if (el) autoResizeComments(el); }}
                   style={{ resize: 'none', overflow: 'hidden', minHeight: 0 }}
                   onInput={(e) => autoResizeComments(e.target)}
               />
              </div>
              <div className="mb-3 mt-2">
               <label htmlFor="email" className='form-label'>Title Company Email Address</label>
               {editFlag
               ? <input className='form-control' id="email" onChange={(e)=>onChangeEvent(e)} type="email" value={request.email} />
               : <input className='form-control' id="email" onChange={(e)=>onChangeEvent(e)} type="email" value={request.email} readOnly/>}
              </div>
              <div className="mb-3 mt-2">
               <label htmlFor="appt_firm_name" className='form-label'>Title Company</label>
               {editFlag
               ? <input className='form-control' id="appt_firm_name" onChange={(e)=>onChangeEvent(e)} type="text" value={request.appt_firm_name} />
               : <input className='form-control' id="appt_firm_name" onChange={(e)=>onChangeEvent(e)} type="text" value={request.appt_firm_name} readOnly/>}
              </div>
              <div className="mb-3 mt-2">
              <label htmlFor="appt_fee" className='form-label'>Title Company Service Fee</label>
                {editFlag
                ? <input className='form-control' id="appt_fee" onChange={(e)=>onChangeEvent(e)} type="text" value={setServiceFee()} />
                : <input className='form-control' id="appt_fee" onChange={(e)=>onChangeEvent(e)} type="text" value={setServiceFee()} readOnly/>}
               </div>
              <div className="mb-3 mt-2">
               <label htmlFor="appt_escrow" className='form-label'>Title Company Escrow Officer</label>
               {editFlag
               ? <input className='form-control' id="appt_escrow" onChange={(e)=>onChangeEvent(e)} type="text" value={request.appt_escrow} />
               : <input className='form-control' id="appt_escrow" onChange={(e)=>onChangeEvent(e)} type="text" value={request.appt_escrow} readOnly/>}
              </div>
              <div className="mb-3 mt-2">
               <label htmlFor="contactName" className='form-label'>Signer Contact Name</label>
               {editFlag
               ? <input className='form-control' id="contactName" onChange={(e)=>onChangeEvent(e)} type="text" value={request.contactName} />
               : <input className='form-control' id="contactName" onChange={(e)=>onChangeEvent(e)} type="text" value={request.contactName} readOnly/>}
              </div>
              <div className="row">
               <div className="col mb-3 mt-2">
                <label htmlFor="contactPhone1" className='form-label'>Signer Contact Phone 1</label>
                {editFlag
                ? <input className='form-control' id="contactPhone1" onChange={(e)=>onChangeEvent(e)} type="tel" value={request.contactPhone1} />
                : <input className='form-control' id="contactPhone1" onChange={(e)=>onChangeEvent(e)} type="tel" value={request.contactPhone1} readOnly/>}
               </div>
               <div className="col mb-3 mt-2">
                <label htmlFor="contactPhone2" className='form-label'>Signer Contact Phone 2</label>
                {editFlag
                ? <input className='form-control' id="contactPhone2" onChange={(e)=>onChangeEvent(e)} type="tel" value={request.contactPhone2} />
                : <input className='form-control' id="contactPhone2" onChange={(e)=>onChangeEvent(e)} type="tel" value={request.contactPhone2} readOnly/>}
               </div>
              </div>
              <div className="row">
               <div className="col mb-3 mt-2">
                <label htmlFor="contactEmail1" className='form-label'>Signer Email Address 1</label>
                {editFlag
                ? <input className='form-control' id="contactEmail1" onChange={(e)=>onChangeEvent(e)} type="email" value={request.contactEmail1} />
                : <input className='form-control' id="contactEmail1" onChange={(e)=>onChangeEvent(e)} type="email" value={request.contactEmail1} readOnly/>}
               </div>
               <div className="col mb-3 mt-2">
                <label htmlFor="contactEmail2" className='form-label'>Signer Email Address 2</label>
                {editFlag
                ? <input className='form-control' id="contactEmail2" onChange={(e)=>onChangeEvent(e)} type="email" value={request.contactEmail2} />
                : <input className='form-control' id="contactEmail2" onChange={(e)=>onChangeEvent(e)} type="email" value={request.contactEmail2} readOnly/>}
               </div>
              </div> 
              <div className='mx-3'>
                Agent Count In Region: {request.notaryCount}
                <br/>
                Available Preferred Agents: {request.preferredNotary.map((items => 
                <div>{items.notary_firstName} {items.notary_lastName} {items.notary_email} {items.notaryPhone}</div>))}
              </div>
              </div>

              </div>
             {notaryFeeEditFlag
             ? (<div><div className='flex flex-wrap gap-3 mb-3'>
                <input className='bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors cursor-pointer' type="submit" value="Preview"/>
                <button className="bg-red-100 hover:bg-red-200 text-red-700 font-medium py-2 px-4 rounded-lg border border-red-300 transition-colors" aria-label="Close" onClick={() => updateStatus('setCanceled')}>Set to Canceled</button>
                </div>
                </div>
             )
             : <div className="flex flex-wrap gap-3 mb-3">
               <input className='bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-lg transition-colors cursor-pointer' type="submit" value="Update"/>
               <button className='bg-neutral-100 hover:bg-neutral-200 text-neutral-700 font-medium py-2 px-4 rounded-lg border border-neutral-300 transition-colors' onClick={() => updateEditFlags(true)}>Edit</button>
             {editedContent
             ? <button className='bg-neutral-100 text-neutral-400 font-medium py-2 px-4 rounded-lg border border-neutral-200 cursor-not-allowed' disabled>Send to Notaries</button>
             : (<>
               <button className='bg-neutral-100 hover:bg-neutral-200 text-neutral-700 font-medium py-2 px-4 rounded-lg border border-neutral-300 transition-colors' onClick={() => submitNotify()}>Send to Notaries</button>
               <button className='bg-neutral-100 hover:bg-neutral-200 text-neutral-700 font-medium py-2 px-4 rounded-lg border border-neutral-300 transition-colors' onClick={() => submitPreferNotify()}>Send to Preferred Agents</button>
               <button className='bg-neutral-100 hover:bg-neutral-200 text-neutral-700 font-medium py-2 px-4 rounded-lg border border-neutral-300 transition-colors' onClick={() => assignDirect()}>Directly Assign Notary</button>
             </>)
            }
             </div>
             }
            </form>
            </div>
            <Fragment>
              <GeneralGroupFileUpload requestId={data.requestId} clearResponseMessage={clearResponseMessage}/>
            </Fragment>
                          <div className="row mt-3">
                <div className='col mx-3'><h6>File Attachment List:</h6></div>
              </div>
              <div className="card bg-light mb-2">
                {request.fileLogInfo.map(o =>
                  <div className="card-body border">
                    <div className="row">
                      <button className="btn-light btn mt-3 mb-4 mx-5" title="Delete File" id={o.fileName} style={{ backgroundImage: "url(/img/trash.svg)", backgroundSize: 'cover', backgroundRepeat: "no-repeat", width: '14px', height: '28px' }} onClick={() => deleteFile(o.fileName)}></button>
                      <button className="list-group-item border-light bg-light text-left text-decoration-underline text-primary" title="Download File" type="button" onClick={() => { getTempUrl(o.fileName) }}>{o.fileName}</button>
                    </div>
                    <div className="card-footer">
                      {o.fileReadInfo.map(info =>
                        <div> <p className="small">{setAction(info.action)} by {info.user} - {convertToSimpleDateMessage(info.loggedTime)} <GeneralUploadStatus confirm={info.confirmed} action={info.action} /></p></div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            )}
            {directlyAssign &&
            <Fragment>
                <AdminAssignDirect requestId={data.requestId}/>
            </Fragment>}
            {showPopup && <PopupOverlay clearModal={clearModal} confirmAction={confirmAction} passedMessage={passedMessage} passedObject={passedObject} />}
            {isLoading && 
                (<div className="d-flex justify-content-center mb-4 mt-4">
                    <div className="spinner-border" role="status">
                    <   span className="visually-hidden"></span>
                    </div>
                </div>)}
            {showResponseMessage && <div>{responseMessage}</div>}
        </Fragment>
    )
   };

export default AdminEditRequest;